module.exports = __webpack_public_path__ + "static/media/dem.4b096d8e.svg";